import { createAction, props } from '@ngrx/store'
import { User } from '@app/data/model/user.model'
import { KeycloakProfile } from 'keycloak-js'
import { InnplaceList } from '@app/data/model/innplaceList.model'
import { HttpErrorResponse } from '@angular/common/http'

export const openMenu = createAction('[stage] Open Menu')

export const closeMenu = createAction('[stage] Close Menu')

export const toggleMenu = createAction('[stage] Toggle Menu')

export const addBreadcrumb = createAction('[stage] Add Breadcrumb', props<{ breadcrumb: any }>())

export const clearBreadcrumbs = createAction('[stage] Clear Breadcrumbs')

export const setSearchData = createAction('[stage] Set SearchData', props<{ searchData: any }>())

export const clearSearchData = createAction('[stage] Clear SearchData')

export const setPrefilterData = createAction('[stage] Set PrefilterData', props<{ prefilterData: any }>())

export const clearPrefilterData = createAction('[stage] Clear PrefilterData')

export const setPrivacyStatement = createAction('[stage] Set isPrivacyStatementAccepted', props<{ privacyStatement: boolean }>())

export const setUser = createAction('[stage] Setting user', props<{ user: User }>())

export const setKcUser = createAction('[stage] Set Keycloak User', props<{ user: KeycloakProfile }>())

export const loadInnplaceLists = createAction('[stage] loadInnplaceLists')

export const loadInnplaceListsSuccess = createAction('[stage] loadInnplaceListsSuccess', props<{ innplaceList: InnplaceList }>())

export const loadInnplaceListsFailed = createAction('[stage] loadInnplaceListsFailed', props<{ error: HttpErrorResponse }>())